/* tslint:disable */
/* eslint-disable */
/**
 * LWM portal
 * Lamb-Weston Meijer Portal API documentation
 *
 * The version of the OpenAPI document: 3.3.9
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
/**
 * ContentApi - axios parameter creator
 * @export
 */
export const ContentApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get the content from the corporate website in json format
         * @summary Get the content
         * @param {string} webspace The webspace name
         * @param {string} locale The requested locale
         * @param {string} path The complete path of the page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        contentWebspaceLocalePathGet: async (webspace: string, locale: string, path: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'webspace' is not null or undefined
            assertParamExists('contentWebspaceLocalePathGet', 'webspace', webspace)
            // verify required parameter 'locale' is not null or undefined
            assertParamExists('contentWebspaceLocalePathGet', 'locale', locale)
            // verify required parameter 'path' is not null or undefined
            assertParamExists('contentWebspaceLocalePathGet', 'path', path)
            const localVarPath = `/content/{webspace}/{locale}/{path+}`
                .replace(`{${"webspace"}}`, encodeURIComponent(String(webspace)))
                .replace(`{${"locale"}}`, encodeURIComponent(String(locale)))
                .replace(`{${"path+"}}`, encodeURI(String(path)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication development-5i2kpscjb65ib9kesn4v8t0121 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "development-5i2kpscjb65ib9kesn4v8t0121", [], configuration)

            // authentication production-65i3ire9nqi9c80lduc24r7rjq required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "production-65i3ire9nqi9c80lduc24r7rjq", [], configuration)

            // authentication staging-6ggnttq03clhsfllacr07d2uit required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "staging-6ggnttq03clhsfllacr07d2uit", [], configuration)



            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ContentApi - functional programming interface
 * @export
 */
export const ContentApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ContentApiAxiosParamCreator(configuration)
    return {
        /**
         * Get the content from the corporate website in json format
         * @summary Get the content
         * @param {string} webspace The webspace name
         * @param {string} locale The requested locale
         * @param {string} path The complete path of the page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async contentWebspaceLocalePathGet(webspace: string, locale: string, path: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.contentWebspaceLocalePathGet(webspace, locale, path, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ContentApi - factory interface
 * @export
 */
export const ContentApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ContentApiFp(configuration)
    return {
        /**
         * Get the content from the corporate website in json format
         * @summary Get the content
         * @param {string} webspace The webspace name
         * @param {string} locale The requested locale
         * @param {string} path The complete path of the page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        contentWebspaceLocalePathGet(webspace: string, locale: string, path: string, options?: any): AxiosPromise<void> {
            return localVarFp.contentWebspaceLocalePathGet(webspace, locale, path, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ContentApi - object-oriented interface
 * @export
 * @class ContentApi
 * @extends {BaseAPI}
 */
export class ContentApi extends BaseAPI {
    /**
     * Get the content from the corporate website in json format
     * @summary Get the content
     * @param {string} webspace The webspace name
     * @param {string} locale The requested locale
     * @param {string} path The complete path of the page
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContentApi
     */
    public contentWebspaceLocalePathGet(webspace: string, locale: string, path: string, options?: any) {
        return ContentApiFp(this.configuration).contentWebspaceLocalePathGet(webspace, locale, path, options).then((request) => request(this.axios, this.basePath));
    }
}
